<template>
  <form-wrapper>
    <form-group>
      <validation-provider v-slot="{errors}" rules="required">
        <icu-select
          :errors="[...errors, ...getFieldErrors('target')]"
          :options="targetChoices"
          :value="stepFormData.target"
          :label="$t('application-form.step-6.target')"
          required
          multiple
          :placeholder="$t('application-form.step-6.target-hint')"
          @input="emitInput('target', $event)"
        />
      </validation-provider>
      <validation-provider v-slot="{errors}" rules="required">
        <icu-select
          :errors="[...errors, ...getFieldErrors('frequency')]"
          :options="frequencyChoices"
          :value="stepFormData.frequency"
          :label="$t('application-form.step-6.frequency')"
          :placeholder="$t('application-form.step-6.frequency-hint')"
          required
          @input="emitInput('frequency', $event)"
        />
      </validation-provider>
      <text-input
        :value="$options.todayDate"
        :label="$t('application-form.step-6.date')"
        required
        disabled
      />
    </form-group>
  </form-wrapper>
</template>

<script>
import FormWrapper from '@/components/views/RegisterPage/FormWrapper.vue'
import FormGroup from '@/components/views/RegisterPage/FormGroup.vue'
import TextInput from '@/components/inputs/TextInput.vue'
import { format } from 'date-fns'
import IcuSelect from '@/components/inputs/IcuSelect.vue'
import {ValidationProvider} from 'vee-validate'
import { api } from '@/api/api.js'

export default {
  name: 'FifthStep',
  components: { IcuSelect, ValidationProvider, TextInput, FormGroup, FormWrapper },
  props: {
    stepFormData: {
      type: Object,
      required: true
    },
    backendErrors: {
      type: Object,
      default: () => {}
    }
  },
  todayDate: format(new Date(), 'dd.MM.yyyy'),
  data() {
    return {
      frequencyChoices: [],
      targetChoices: []
    }
  },
  async beforeMount() {
    const { data: frequencies } = await api.profile.getBusinessFrequencies()
    const { data: targets } = await api.profile.getBusinessTargets()

    this.frequencyChoices = frequencies
    this.targetChoices = targets

    this.setInitialValues()
  },
  methods: {
    emitInput(formKey, value) {
      this.$emit('update-field', {formKey, value})
    },
    getFieldErrors(fieldName) {
      return this.backendErrors[fieldName] ?? []
    },
    setInitialValues() {
      const isFrequencyUnfilled = this.stepFormData.frequency === null
      if (isFrequencyUnfilled) {
        const frequency = this.frequencyChoices.find(item => item.default_checked)

        this.emitInput('frequency', frequency?.id)
      }

      const isTargetUnfilled = !(this.stepFormData.target?.length > 0)
      if (isTargetUnfilled) {
        const targetsToSelect = this.targetChoices.filter(target => target.default_checked)

        this.emitInput('target', targetsToSelect.map(target => target.id))
      }
    }
  }
}
</script>

<style scoped>

</style>
